export const classPrefix = 'BidirectionalStepper';

export interface IStepperState {
  left: boolean;
  right: boolean;
  mid: boolean;
}

export enum StepperSize {
  small = 'small',
  regular = 'regular',
}
export interface IBidirectionalStepper {
  minWidth?: number;
  stepperSize?: StepperSize,

  disableState?: IStepperState;
  selectState?: IStepperState;
  isFloorPlan?: boolean;

  enableUnFocusForMouseLeave?: boolean;

  handleLeftClick: () => void;
  handleRightClick: () => void;
  handleMiddleClick: () => void;

  handleUnFocus?: () => void;

  children: any;
  parentRef: any;
}
